export enum GridFilterType {
  None = 0,
  Orders = 1,
  Customers = 2,
  OrderItems = 3,
}
